import React from "react";
import { Button, Col, Row } from "react-bootstrap";

import classNames from "classnames";

import { useGameSummaryContext } from "../contexts/GameSummary";

import Loading from "../../../../../components/Loading";

const SubmitButton = (): React.JSX.Element => {
    const { methods, fetchStatus, submitButtonText } = useGameSummaryContext();

    return (
        <Row data-testid="submitButton">
            <Col className={classNames("d-flex", "align-items-baseline")}>
                <Button
                    variant="primary"
                    type="submit"
                    disabled={
                        Object.keys(methods.formState.errors).length !== 0 ||
                        fetchStatus === "pending"
                    }
                >
                    {submitButtonText}
                </Button>
                {fetchStatus === "pending" && (
                    <Loading className="mx-3 w-auto" />
                )}
            </Col>
        </Row>
    );
};

export default SubmitButton;
